import OrdersService from "@/Services/OrdersService";
export const ordersModule = {
    namespaced : true,
    state:{

    }
    , actions:{
        GetPendingOrders({commit} , payload){
            return OrdersService.GetAllPendingByServicePlace(payload.ServicePlaceId).then(res=>{
                return Promise.resolve(res);
            })
        }
        //GetCurrentOrders
        ,
        GetCurrentOrders({commit} , payload){
            return OrdersService.GetCurrentOrders(payload).then(res=>{
                const list = (res && res.data != null) ? res.data : (Array.isArray(res) ? res : []);
                return Promise.resolve(list);
            })
        },
        //GetAllPendingUserOrders
        GetAllPendingUserOrders({commit} ){
            return OrdersService.GetAllPendingUserOrders().then(res=>{
                return Promise.resolve(res.data);
            })
        },

        //GetAllDoneUserOrders
        GetAllDoneUserOrders({commit} ){
            return OrdersService.GetAllDoneUserOrders().then(res=>{
                return Promise.resolve(res.data);
            })
        },

        NewOrder({ commit }, { offerId, note }) {
            return OrdersService.NewOrder(offerId, note);
        },

        GetUserOrderById({ commit }, orderId) {
            return OrdersService.GetUserOrderById(orderId);
        },

        OrderApprove({ commit }, orderId) {
            return OrdersService.Approve(orderId);
        },

        OrderDisApprove({ commit }, orderId) {
            return OrdersService.DisApprove(orderId);
        },

        GetMessageDepositFromUserWallet({ commit }, orderId) {
            return OrdersService.GetMessageDepositFromUserWallet(orderId);
        },

        ApplyDepositFromUserWallet({ commit }, orderId) {
            return OrdersService.ApplyDepositFromUserWallet(orderId);
        },

        CancelDepositFromUserWallet({ commit }, orderId) {
            return OrdersService.CancelDepositFromUserWallet(orderId);
        },

        ScanOrderQrCode({ commit }, { OrderCode, BranchId }) {
            return OrdersService.ScanOrderQrCode(OrderCode, BranchId);
        }
    }
    ,mutations: {

    },getters:{
    }

}